import { Injectable } from '@angular/core';
import { RequestCRUD } from 'src/app/shared/services/abstract/request-crud.service';
import { RNTFuncionarioEntry } from 'src/app/shared/entrys/rnt-funcionario.entry';
import { ResponseServiceModel } from 'src/app/shared/models/response-service.model';
import { EnviromentGlobalService } from 'src/app/shared/services/enviroment-global.service';
import { HttpClient } from '@angular/common/http';
import { retry } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class ReversarEstadoService implements RequestCRUD<RNTFuncionarioEntry, ResponseServiceModel>  {

  private API_URL;

  constructor(private http: HttpClient, private enviromentGlobalService: EnviromentGlobalService) {
    this.API_URL = enviromentGlobalService.apiUrl;
  }

  get(entry: RNTFuncionarioEntry): import('rxjs').Observable<ResponseServiceModel> {
    throw new Error('Method not implemented.');
  }

  getConsultaUltimaSolicitud(entry: any): Observable<ResponseServiceModel> {
    return this.http.get<ResponseServiceModel>(`${this.API_URL}/Solicitud/ConsultaUltimaSolicitud/${entry.codigo}/${entry.tipo_filtro}`).pipe(retry(2));
  }

  getEstadosPorTipoSolicitudReversion(entry: any): Observable<ResponseServiceModel> {
    // tslint:disable-next-line: max-line-length
    return this.http.post<ResponseServiceModel>(`${this.API_URL}/Solicitud/GetEstadosPorTipoSolicitudReversion/${entry.tipo_solicitud_id}`, entry).pipe(retry(2));
  }

  changeRevertirEstado(entry: any): Observable<ResponseServiceModel> {
    return this.http.post<ResponseServiceModel>(`${this.API_URL}/Solicitud/RevertirEstado`, entry).pipe(retry(2));
  }

  update(entry: RNTFuncionarioEntry): import('rxjs').Observable<ResponseServiceModel> {
    throw new Error('Method not implemented.');
  }
  create(entry: RNTFuncionarioEntry): import('rxjs').Observable<ResponseServiceModel> {
    throw new Error('Method not implemented.');
  }
  delete(entry: RNTFuncionarioEntry): import('rxjs').Observable<ResponseServiceModel> {
    throw new Error('Method not implemented.');
  }

}
